import { LOCAL, ROOT_FLAG } from "@/store/mutations";

const { SET_TRICK_SELECTION, SET_TRICK_OWNERSHIP } = LOCAL;

export default {
	namespaced: true,
	state: {
		id: null,
		type: "",
		title: "",
		cost: 0,
		score_modifiers: {},
		animation: {},
		owned: false,
		selected: false,
	},
	actions: {
		toggleSelection({ commit, state }) {
			commit(SET_TRICK_SELECTION, { selected: !state.selected });
		},
		purchase({ dispatch, state }, fund) {
			dispatch(`global/analytics/trackEvent`, { ec: "In Game", ea: "Trick Purchased", el: state.title }, ROOT_FLAG);
			dispatch(`game/funds/${fund.id}/withdraw`, { amount: state.cost }, ROOT_FLAG);
			dispatch("acquire");
		},
		acquire({ commit, dispatch, state }) {
			dispatch("global/assets/loadFile", {
				id: state.video.id,
				url: state.video.url,
			}, ROOT_FLAG);
			commit(SET_TRICK_OWNERSHIP, { owned: true });
			commit(SET_TRICK_SELECTION, { selected: false });
		},
		perform({ state, dispatch }) {
			Object.entries(state.score_modifiers).forEach(([scoreId, modifier]) => {
				dispatch(`game/scores/${scoreId}/modify`, { amount: modifier }, ROOT_FLAG);
			});
		},
	},
	mutations: {
		[SET_TRICK_SELECTION](state, trick) {
			state.selected = trick.selected;
		},
		[SET_TRICK_OWNERSHIP](state, trick) {
			state.owned = trick.owned;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/tricks/single.store.js